import React from "react";
import { Layout, Menu, Button, Dropdown } from "antd";
import {
  UserOutlined,
  LogoutOutlined,
  DashboardOutlined,
} from "@ant-design/icons";
import { withTranslation, WithTranslation } from "react-i18next";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { JS_COOKIE } from "util/auth";
import Logo_Icon from "../general/assets/Logo_Icon.png";

const { Header, Content, Sider } = Layout;

interface CoachLayoutProps extends WithTranslation, RouteComponentProps {
  children: React.ReactNode;
}

const CoachLayout: React.FC<CoachLayoutProps> = ({ children, t, history }) => {
  const handleLogout = () => {
    JS_COOKIE.remove("token");
    history.push("/login");
  };

  const userMenu = (
    <Menu>
      <Menu.Item key="profile" icon={<UserOutlined rev={undefined} />}>
        {t("coach.profile")}
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item
        key="logout"
        icon={<LogoutOutlined rev={undefined} />}
        onClick={handleLogout}
      >
        {t("coach.logout")}
      </Menu.Item>
    </Menu>
  );

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Layout>
        <Layout style={{ padding: "0" }}>
          <Content
            style={{
              background: "#f0f2f5",
              minHeight: "calc(100vh - 64px)",
              overflow: "auto",
            }}
          >
            {children}
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default withRouter(withTranslation()(CoachLayout));
